import { useRequiredContext } from "@redotech/react-util/context";
import { CartRewardsType } from "@redotech/redo-model/cart/cart-rewards";
import {
  cartRewardsDefaults,
  getEvaluatedCartRewardsMessage,
} from "@redotech/redo-model/cart/cart-rewards-defaults";
import { memo } from "react";
import { CartOptModificationsContext } from "./cart-opt-modifications";
import { CartOptimizationContext } from "./cart-optimization-context";
import { CartRewardsUi } from "./cart-rewards-ui";

export const FreeShippingRewards = memo(function FreeShippingRewards() {
  const cartOptimizationContext = useRequiredContext(CartOptimizationContext);
  const cartContext = useRequiredContext(CartOptModificationsContext);

  const cartRewards = cartOptimizationContext.autocheck.cartRewards;

  if (!cartRewards || cartRewards.type !== CartRewardsType.SHIPPING) {
    return null;
  }

  const { threshold, approachingThresholdMessage, pastThresholdMessage } =
    cartRewards;

  const currentTotal =
    cartContext.dueTodaySubtotal ?? cartContext.dueTodayTotal;
  const remainingAmount = Math.max(0, threshold * 100 - currentTotal);
  const hasReachedThreshold = remainingAmount === 0;

  const remainingFormatted = cartContext.formatCurrency(
    remainingAmount,
    cartContext.currency,
  );

  const message = hasReachedThreshold
    ? getEvaluatedCartRewardsMessage(
        pastThresholdMessage,
        cartRewardsDefaults.pastThresholdMessage,
      )
    : getEvaluatedCartRewardsMessage(
        approachingThresholdMessage,
        cartRewardsDefaults.approachingThresholdMessage,
        { remainingToRewardsTier: remainingFormatted },
      );

  const progressPercentage = Math.min(
    100,
    (currentTotal / (threshold * 100)) * 100,
  );

  return (
    <CartRewardsUi
      hasReachedThreshold={hasReachedThreshold}
      message={message}
      progressPercentage={progressPercentage}
    />
  );
});
